import { render, staticRenderFns } from "./default.vue?vue&type=template&id=67e84e3b&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=67e84e3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e84e3b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Im: require('/drone/src/components/im/index.vue').default,AppHeader: require('/drone/src/components/AppHeader.vue').default,AppMain: require('/drone/src/components/AppMain.vue').default,RightTools: require('/drone/src/components/RightTools/index.vue').default,AppFooter: require('/drone/src/components/AppFooter.vue').default,Darkmode: require('/drone/src/components/Darkmode/index.vue').default,ReplenishInfo: require('/drone/src/components/replenishInfo/index.vue').default,PzNotify: require('/drone/src/components/pz-notify/index.vue').default})
